<template>
  <div>
    <section class="section">
      <!-- navbar -->
      <NavBar @toggleQueue="toggleQueue" />
      <!-- error -->
      <Error />
      <router-view />
    </section>
    <Queue :queueState="queueState" />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Error from "@/components/Error.vue";
import Queue from "../components/Queue.vue";
//import { user } from "./../services/user";
export default {
  components: {
    NavBar,
    Error,
    Queue,
  },
  data() {
    return {
      queueState: false,
    };
  },
  computed: {},
  methods: {
    toggleQueue(queueState) {
      this.queueState = !queueState;
    },
  },
};
</script>
<style>
form .columns {
  margin-bottom: 0 !important;
}
.section {
  padding: 0 0.5rem !important;
}
nav .icon {
  display: none;
  padding-right: 12px !important;
}
nav span.tag {
  margin-left: 5px;
}
</style>
